import { render, staticRenderFns } from "./mgmtLists.vue?vue&type=template&id=74b56170&scoped=true&"
import script from "./mgmtLists.vue?vue&type=script&lang=js&"
export * from "./mgmtLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b56170",
  null
  
)

export default component.exports